var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
/**
 * [CLAIMS_CONTEXT]
 * purpose: Displays an incremental input for a single good damage type within a category,
 * allowing users to add or remove good damage occurrences.
 * touches: good damage declaration flow, room damage store (add/pop good damage)
 * invariants: count reflects goodDamages filtered by type+category+room;
 * onUpdate diffs current count and calls add/pop accordingly
 * inputs: category, type props; goodDamages and room from GoodDamagesComponent mixin
 * outputs: addNewGoodDamage, popGoodDamage dispatched to room damage store
 * see: frontend/src/declaration/components/roomDamage/goodDamage/GoodDamageComponent.ts,
 * frontend/src/shared/roomDamage/goodDamage.ts
 */
import Component from 'vue-class-component';
import { UiIncremental, UiList } from '@claims-ia/design-system';
import { GoodDamagesComponent } from './GoodDamageComponent';
import { getGoodDamageTypeDefinition, } from '@shared/roomDamage/goodDamage';
let GoodDamageTypesInput = class GoodDamageTypesInput extends GoodDamagesComponent {
    get definition() {
        return this.room && getGoodDamageTypeDefinition(this.room, this.category, this.type);
    }
    get label() {
        var _a;
        const tradKey = (_a = this.definition) === null || _a === void 0 ? void 0 : _a.tradKey;
        return tradKey ? this.$tc(tradKey) : '';
    }
    get illustration() {
        var _a, _b;
        return (_b = (_a = this.definition) === null || _a === void 0 ? void 0 : _a.illustration) !== null && _b !== void 0 ? _b : undefined;
    }
    get count() {
        return this.goodDamages.filter((goodDamage) => goodDamage.type === this.type &&
            goodDamage.category === this.category &&
            goodDamage.room === this.room).length;
    }
    get items() {
        return [
            {
                id: this.type,
                title: this.label,
                imageURL: this.illustration,
                imageLabel: this.label,
                isActive: false,
                count: this.count,
            },
        ];
    }
    onUpdate(value) {
        if (!this.room)
            return;
        let diff = value - this.count;
        while (diff < 0) {
            diff++;
            this.popGoodDamage(this.category, this.type);
        }
        while (diff > 0) {
            diff--;
            this.addNewGoodDamage(this.category, this.type);
        }
    }
};
GoodDamageTypesInput = __decorate([
    Component({
        components: {
            UiIncremental,
            UiList,
        },
        props: {
            category: { type: String, required: true },
            type: { type: String, required: true },
        },
    })
], GoodDamageTypesInput);
export default GoodDamageTypesInput;
